<template lang="pug">
// ----------------- modal termos -----------------
v-dialog(v-model="dialog" persistent width="600px")
  template(v-slot:activator="{ on }")

  v-card
    v-card-title
      span(class="headline") Deseja aceitar os termos de uso?
    v-card-text
      p
      h4 TERMO DE RESPONSABILIDADE DE ACESSO AO BANCO DE DADOS
      p
      p Pelo presente instrumento, ao aceitar este termo, o usuário incorrerá na qualidade de corresponsabilidade pela guarda e uso do banco de dados, assumindo as seguintes responsabilidades:
      p a) Utilizar esta base de dados única e exclusivamente para as finalidades devidas ao escopo do negócio;
      p b) Guardar sigilo e zelar pela privacidade dos indivíduos relacionados/listados nesta(s) base(s) de dados;
      p c) Não disponibilizar, emprestar ou permitir a pessoas ou instituições não autorizadas o acesso à esta(s) base(s) de dados;
      p d) Não divulgar, por qualquer meio de comunicação, dados ou informações contendo o nome dos indivíduos ou outras variáveis que permitam a identificação do indivíduo e que afetem assim a confidencialidade dos dados contidos nesta(s) base(s) de dados;
      p e) Não praticar ou permitir qualquer ação que comprometa a integridade desta(s) base(s) de dados;
      p f) Não utilizar isoladamente as informações contidas nesta(s) base(s) de dados para tomar decisões sobre a identidade de pessoas.
      p Desta forma, o usuário administrador, ciente dos termos da Lei Geral de Proteção de Dados (LGPD) assume total responsabilidade pelas consequências legais na utilização indevida desta(s) base(s) de dados, por parte de proprietários, funcionários e/ou prestadores de serviços desta instituição ou por terceiros que venham a utilizar o sistema e ter acesso ao banco de dados.

    v-card-actions(style="background-color: white")
      v-btn(color="gray" text @click="logout") Sair
      v-btn(color="blue darken-1" text @click="accept") {{ confirmationText }}
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      dialog: '',
      userId: '',
      confirmationText: 'Concordar e proseguir'
    }),
    methods:{
      ...mapActions(['editUser']),
      logout(){
        this.$store.dispatch('userLogout')
        this.dialog = false
      },
      async accept(){
        this.confirmationText = 'Aguarde...'
        await this.editUser({
          '_id': this.userId,
          'termos': true
        })
        this.dialog = false
      }
    },
    created(){

    },
    mounted(){
      const userData = JSON.parse(window.localStorage.getItem("user"))
      //this.dialog = true
      this.dialog = !userData.termos
      this.userId = userData._id
    }
  }
</script>
